// ==========================================================================
// Plyr states
// ==========================================================================
export var pip={active:'picture-in-picture',inactive:'inline'};export default{pip:pip};